import * as React from 'react';
import { ECompetitorsLevel } from '../../../../../../../reducers/v2';
import { HighCompetitionLevel } from './components/HighCompetitionLevel';
import { MediumCompetitionLevel } from './components/MediumCompetitionLevel';
import { LowCompetitionLevel } from './components/LowCompetitionLevel';

type TCompetitionLabelProps = {
  level: ECompetitorsLevel;
};

export const CompetitionLabel = ({ level }: TCompetitionLabelProps) => {
  switch (level) {
    case ECompetitorsLevel.high:
      return <HighCompetitionLevel />;
    case ECompetitorsLevel.medium:
      return <MediumCompetitionLevel />;
    case ECompetitorsLevel.low:
      return <LowCompetitionLevel />;
    default:
      return null;
  }
};
